/**
 * Section constants - browser-safe, zero imports.
 * This is the foundation file that other section files build upon.
 */
const sectionTypes = {
    STANDARD: 'standard',
    SUPERSET: 'superset',
    CIRCUIT: 'circuit',
    AMRAP: 'amrap',
    EMOM: 'emom',
};
/**
 * Describes how the exercises within the section are performed relative
 * to each other.
 * sequential: Perform all sets for exercise 1, then move to exercise 2. (This is for standard type).
 * interleaved: Perform one set of exercise 1, then one set of exercise 2, etc., and repeat. (This is for superset and circuit).
 */
const sectionTypeExecutionStrategies = {
    SEQUENTIAL: 'sequential',
    INTERLEAVED: 'interleaved',
};
/*
 * These correspond to the columns in the section_plan table
 * @todo: add detailed description what this is used for.
 */
const sectionTypeInputs = {
    ROUNDS: 'rounds',
    DURATION_SECONDS: 'durationSeconds',
    INTERVAL_SECONDS: 'intervalSeconds',
};
// @todo: add detailed description what this is used for.
const repetitionModificationLevels = {
    SECTION_PLAN: 'sectionPlan',
    STEP_PLAN: 'stepPlan',
    SET_PLAN: 'setPlan',
};
export { repetitionModificationLevels, sectionTypeExecutionStrategies, sectionTypeInputs, sectionTypes, };
//# sourceMappingURL=section.constants.js.map